import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { getNotifications } from '../store/actions/notificationsActions';
import './Notifications.scss';

import Spinner from "./_common/Spinner";
import NotificationsList from "./NotificationsList";

const selector = state => {
    const { language, notifications } = state;
    return {
        t: language.translator,
        pendingNotifications: notifications.pending,
        notifications: notifications.notifications
    }
};

const Notifications = () => {
    const { t, pendingNotifications, notifications } = useSelector(selector);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getNotifications());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if(pendingNotifications) {
        return (
            <div className='page'>
                <Spinner size={300}/>
            </div>
        );
    }

    return (
        <div className='notifications'>
            <div className='notificationsHeader'>{t.gettext('Notifications')}</div>
            <div className='notificationsBox'>
                {!notifications.length
                    ? <div>{t.gettext('No notifications')}</div>
                    : <NotificationsList
                        notifications={notifications}
                        title={t.gettext('Today')}
                    />
                }
            </div>
        </div>
    );
};

export default Notifications;
